/**
 * 常用服务
 * useful server
 */
export const qzhd = [
 
    {
      title:"走访宣传",
      icon:require("@images/icon/icon-zfxc.png"),
      code:'A07A05'
    }
    ,{
      title:"居民咨询",
      icon:require("@images/icon/icon-jmzx.png"),
       code:'A07A29'
    },{
      title:"居民办事",
      icon:require("@images/icon/icon-jmbs.png"),
       code:'A07A31'
    },{
      title:"企业咨询",
      icon:require("@images/icon/icon-qyzx.png"),
       code:'A07A30'
    },{
      title:"企业办事",
      icon:require("@images/icon/icon-qybs.png"),
       code:'A07A32'
    }
   
  ]

  export const shgl = [
 
    {
      title:"环境污染",
      icon:require("@images/icon/icon-hjwr.png"),
       code:'A07A03'
    },{
      title:"气象点维护",
      icon:require("@images/icon/icon-qxdwh.png"),
       code:'A07A11'
    },{
      title:"水利水务巡查",
      icon:require("@images/icon/icon-slsw.png"),
       code:'A07A12'
    },{
      title:"水电路讯气维修",
      icon:require("@images/icon/icon-sdlxxc.png"),
       code:'A07A04'
    },{
      title:"公益诉讼线索",
      icon:require("@images/icon/icon-gyss.png"),
       code:'A07A13'
    },
    {
      title:"人居环境整治",
      icon:require("@images/icon/icon-rjhj.png"),
       code:'A07A14'
    },{
      title:"突发信息",
      icon:require("@images/icon/icon-tfxx.png"),
       code:'A07A01'
    },{
      title:"安全隐患排查",
      icon:require("@images/icon/icon-aqyhpc.png"),
       code:'A07A09'
    },{
      title:"地质灾害监测",
      icon:require("@images/icon/icon-dzzh.png"),
       code:'A07A15'
    },{
      title:"消防普查",
      icon:require("@images/icon/icon-xfpc.png"),
      code:'A07A16'
    },
    {
      title:"食品药品巡查",
      icon:require("@images/icon/icon-spypxc.png"),
       code:'A07A08'
    },
   
  ]


export const zhzf = [
    {
      title:"食品药品",
      icon:require("@images/icon/zhzf-spyp.png"),
      code:'A07A17'
    },{
      title:"劳动保障",
      icon:require("@images/icon/zhzf-ldbz.png"),
       code:'A07A18'
    },{
      title:"安全生产",
      icon:require("@images/icon/zhzf-aqsc.png"),
       code:'A07A19'
    },{
      title:"公共卫生",
      icon:require("@images/icon/zhzf-ggws.png"),
       code:'A07A20'
    },{
      title:"城市管理",
      icon:require("@images/icon/zhzf-csgl.png"),
       code:'A07A21'
    },
    {
      title:"教育培训",
      icon:require("@images/icon/zhzf-jypx.png"),
       code:'A07A22'
    },{
      title:"自然资源",
      icon:require("@images/icon/zhzf-zrzy.png"),
       code:'A07A23'
    },{
      title:"交通运输",
      icon:require("@images/icon/zhzf-jtys.png"),
       code:'A07A24'
    },{
      title:"水利水务",
      icon:require("@images/icon/zhzf-slsw.png"),
       code:'A07A25'
    },{
      title:"生态环境",
      icon:require("@images/icon/zhzf-sthj.png"),
       code:'A07A26'
    },{
      title:"金融类",
      icon:require("@images/icon/zhzf-jrl.png"),
       code:'A07A27'
    },{
      title:"农业农村",
      icon:require("@images/icon/zhzf-nync.png"),
       code:'A07A28'
    },
  ]

  export const gzfwMenu = [
    {
      title:"长武蓝",
      icon:require("@images/gzfw/icon-cwl.png"),
    },
    {
      title:"随手报",
      icon:require("@images/gzfw/icon-ssb.png"),
    },
    {
      title:"党建引领",
      icon:require("@images/gzfw/icon-cxzz.png"),
    },
    {
      title:"法在身边",
      icon:require("@images/gzfw/icon-fzsb.png"),
    },
    {
      title:"办事指南",
      icon:require("@images/gzfw/icon-bszn.png"),
    },
    {
      title:"我要学法",
      icon:require("@images/gzfw/icon-wyxf.png"),
    },
    {
      title:"我要投票",
      icon:require("@images/gzfw/icon-wytp.png"),
    },
    {
      title:"秦务员",
      icon:require("@images/gzfw/icon-qwy.png"),
    },
    {
      title:"物业服务",
      icon:require("@images/gzfw/icon-wyfw.png"),
    },
    {
      title:"旅游景点",
      icon:"/static/gzfw/icon-lyjd.png",
      icon:require("@images/gzfw/icon-lyjd.png"),
    },
    {
      title:"婚姻预约",
      icon:require("@images/icon2/icon-hyyy.png"),
    },
    {
      title:"更多",
      icon:require("@images/gzfw/icon-gd.png"),
    },
   
   
  ]
 


